// extracted by mini-css-extract-plugin
module.exports = {"featureList":"TailwindFeatureList-styles-module--featureList--3jZ_w","nopad":"TailwindFeatureList-styles-module--nopad--2lGf0"};